<template>
  <div class="MilestoneElementList container-fluid margin-Top-Bottom-1Point5Perc" v-bind:class="{'bottom-dotted-border': (this.getElementList.length > this.elementObj.DisplayIndex)}">    
    <div class="admin-Panel-Padding">
      <div class="row vertical-align">
        <div class="col-md-1 col-lg-1">
        </div>
        <div class="col-md-1 col-lg-1">
          <input type="checkbox" value="true" v-model="getIsElementSelectedValue" v-if="showCheckBox">
          <span class="tooltip1 margin-0px cursor-default" v-if="elementObj.Type === 7 && !showCheckBox">
            <img :src="bonusIcon" class="bonus-icon-width-height" alt="bonusIcon">  
            <span class="tooltiptext1">{{getIsBonusContentTooltipValue}}</span>
          </span> 
        </div>
        <div class="col-md-8 col-lg-8">
            <div class="row vertical-align">
              <div class="col-sm-1 col-md-1 col-lg-1 ">
                <img :src="elementImgSrc" class="element-icon-width-height" alt="element-icon">
              </div>
              <div class="col-sm-5 col-md-5 col-lg-5 padding-left-0Perc padding-right-0Perc text-align-left orange-text-color" :class="{'': elementObj.Type === 7}">
                <span class="element-type-font-style">{{elementType}} </span> 
                <span v-if="elementObj.Type !== 7">
                  / {{elementObj.Duration}}
                </span>
                <span class="tooltip1 cursor-default margin-left-2px">
                  <img :src= "getIncludeInProgressSrcValue" class="include-in-progress-width-height margin-right-0px" alt="includeInProgressIcon">  
                  <span class="tooltiptext1">{{getIncludeInProgressTooltipValue}}</span>
                </span>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6">
              </div>
            </div> 
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-left orange-text-color element-name-text-size element-name-style">
                {{elementObj.Title}}
              </div>
            </div>        
        </div>
        <div class="col-md-1 col-lg-1">
        </div>
        <div class="col-md-1 col-lg-1">
        </div>    
      </div>
    </div>
    <milestone-bonus-element-list v-for="bonusEleObj in getBonusElementList" :key="bonusEleObj.ElementId" v-bind:bonusElementObj="bonusEleObj" v-bind:bonusElementList="getBonusElementList" v-bind:elementList="getElementList" v-bind:lessonObj="getLessonObject" v-bind:elementObj="elementObj" @userIntraction="PerformedUserIntraction"></milestone-bonus-element-list>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
  </div>    
</template>

<script>
import MilestoneBonusElementList from '@/components/MilestoneBonusElementList'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import videoicon from '../assets/images/videoicon.svg'
import challengeicon from '../assets/images/challengeicon.svg'
import reflectionicon from '../assets/images/reflectionicon.svg'
import mcqicon from '../assets/images/mcqicon.svg'
import noteicon from '../assets/images/noteicon.svg'
import iconadaptivegame from '../assets/images/iconadaptivegame.svg'
import documenticon from '../assets/images/documents.svg'
import missionicon from '../assets/images/mission.svg'
import excludeinprogressicon from '../assets/images/excludeinprogress.svg'
import includeinprogressicon from '../assets/images/includeinprogress.svg'
import bonusicon from '../assets/images/bonus.svg'
import indexOf from 'lodash/indexOf'
import forEach from 'lodash/forEach'
export default {
  props: ['lessonObj', 'elementObj', 'elementList', 'courseJourneyList'],
  name: 'MilestoneElementList',
  created () {
    this.updateIsElementSelectedFlag()
    this.setElementImageAndType()
  },
  data: function () {
    return {
      includeInProgressTooltip: '',
      isBonusContentTooltip: '',
      includeInProgressSrc: '',
      bonusSrc: '',
      elementImgSrc: '',
      elementType: '',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      bonusIcon: bonusicon,
      isElementSelected: false,
      showCheckBox: false,
      doNotRemoveAllBonusSubElementIds: false
    }
  },
  methods: {
    PerformedUserIntraction (value) {
      this.doNotRemoveAllBonusSubElementIds = value.doNotRemoveAllBonusSubElementIds
      var _this = this
      setTimeout(function () {
        _this.doNotRemoveAllBonusSubElementIds = false
      }, 50)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    setElementImageAndType: function () {
      switch (this.elementObj.Type) {
        case 0:
          this.elementImgSrc = videoicon
          this.elementType = 'Video'
          break
        case 1:
          this.elementImgSrc = challengeicon
          if (parseInt(this.elementObj.SubType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementType = 'Teachback'
          } else {
            this.elementType = 'Challenge'
          }
          break
        case 2:
          this.elementImgSrc = reflectionicon
          this.elementType = 'Reflection'
          break
        case 3:
          this.elementImgSrc = mcqicon
          this.elementType = 'MCQ'
          break
        case 4:
          this.elementImgSrc = videoicon
          this.elementType = 'Tookit'
          break
        case 5:
          this.elementImgSrc = videoicon
          this.elementType = 'Diary'
          break
        case 6:
          this.elementImgSrc = noteicon
          this.elementType = 'Note'
          break
        case 7:
          this.elementImgSrc = videoicon
          this.elementType = 'Bonus'
          break
        case 8:
          this.elementImgSrc = documenticon
          this.elementType = 'Note'
          break
        case 9:
          this.elementImgSrc = videoicon
          if (parseInt(this.elementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementType = 'Teachback'
          } else {
            this.elementType = 'Descriptive Video'
          }
          break
        case 10:
          this.elementImgSrc = noteicon
          this.elementType = 'Rating'
          break
        case 11:
          this.elementImgSrc = iconadaptivegame
          this.elementType = 'Learning Game'
          break
        case 12:
          this.elementImgSrc = missionicon
          this.elementType = 'Mission'
          break
      }
    },
    updateIsElementSelectedFlag: function () {
      var indexNo = indexOf(this.getElementIdsToComplete, this.elementObj.ElementId)
      this.getIsElementSelectedValue = indexNo > -1
      // AK: If the current element type is bonus and it has no bonus videos then disable the checkbox
      if (this.elementObj.Type === 7) {
        this.showCheckBox = false
      } else {
        this.showCheckBox = true
      }
    },
    addOrRemoveElementIdFromList: function () {
      var _this = this
      if (this.getIsElementSelectedValue) {
        // AK: Check weather is already present current Element Id (Somehow)?
        var indexNo = indexOf(_this.$store.state.elementIdsToComplete, this.elementObj.ElementId)
        if (indexNo === -1) {
          _this.$store.state.elementIdsToComplete.push(this.elementObj.ElementId)
        }
        if (this.elementObj.Type === 7) {
          // AK: If current element type is bonus then add all it's associated element id's into the list
          forEach(this.getBonusElementList, function (bonusElementObj) {
            // AK: Check and add the elements only if they are not present in the list
            indexNo = indexOf(_this.$store.state.elementIdsToComplete, bonusElementObj.ElementId)
            if (indexNo === -1) {
              _this.$store.state.elementIdsToComplete.push(bonusElementObj.ElementId)
            }
          })
        }
        console.log('Adding all current Steps: ' + this.$store.state.elementIdsToComplete.length)
      } else {
        // AK: Check weather is already present current Element Id?
        indexNo = indexOf(_this.$store.state.elementIdsToComplete, this.elementObj.ElementId)
        if (indexNo > -1) {
          _this.$store.state.elementIdsToComplete.splice(indexNo, 1)
        } else {
          // console.log('Already removed from list')
        }
        if (this.elementObj.Type === 7 && !this.doNotRemoveAllBonusSubElementIds) {
          // AK: If current element type is bonus then remove all it's associated element id's into the list
          forEach(this.getBonusElementList, function (bonusElementObj) {
            // AK: Check and remove the elements only if they are present in the list
            indexNo = indexOf(_this.$store.state.elementIdsToComplete, bonusElementObj.ElementId)
            if (indexNo > -1) {
              _this.$store.state.elementIdsToComplete.splice(indexNo, 1)
            } else {
              // console.log('Already removed from list')
            }
          })
        }
        console.log('Removing all current Steps: ' + this.$store.state.elementIdsToComplete.length)
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'milestone-bonus-element-list': MilestoneBonusElementList
  },
  watch: {
    getElementIdsToComplete: function (newValue, oldValue) {
      this.updateIsElementSelectedFlag()
    },
    getIsElementSelectedValue: function (newValue, oldValue) {
      this.addOrRemoveElementIdFromList()
    }
  },
  computed: {
    getIsElementSelectedValue: {
      get: function () {
        return this.isElementSelected
      },
      set: function (newValue) {
        this.isElementSelected = newValue
      }
    },
    getElementIdsToComplete: {
      get: function () {
        return this.$store.state.elementIdsToComplete
      }
    },
    getCourseJourneyList: {
      get: function () {
        return this.courseJourneyList
      }
    },
    getLessonObject: {
      get: function () {
        return this.lessonObj
      }
    },
    getBonusElementList: {
      get: function () {
        return this.elementObj.BonusElements
      }
    },
    getElementList: {
      get: function () {
        return this.elementList
      }
    },
    getIncludeInProgressSrcValue: {
      get: function () {
        if (parseInt(this.elementObj.Type) === 0) {
          this.elementObj.IncludeInProgress = true
        }
        this.includeInProgressSrc = this.elementObj.IncludeInProgress ? includeinprogressicon : excludeinprogressicon
        return this.includeInProgressSrc
      }
    },
    getIncludeInProgressTooltipValue: {
      get: function () {
        if (parseInt(this.elementObj.Type) === 0) {
          this.elementObj.IncludeInProgress = true
        }
        this.includeInProgressTooltip = this.elementObj.IncludeInProgress ? constants.Include_In_Progress_True_Tooltip_Text : constants.Include_In_Progress_False_Tooltip_Text
        return this.includeInProgressTooltip
      }
    },
    getIsBonusContentTooltipValue: {
      get: function () {
        this.isBonusContentTooltip = parseInt(this.elementObj.Type) === 7 ? constants.Is_Bonus_Content_True_Tooltip_Text : constants.Is_Bonus_Content_False_Tooltip_Text
        return this.isBonusContentTooltip
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
.opacity-point-2 {
  opacity: 0.5;
}
.opacity-point-5 {
  opacity: 0.9;
}
.left-icon-div {
  float: left;
  width: 5%;
}
.right-element-duration-div {
  float: right;
  width: 83%;
}
.middle-element-type-name-div {
  margin: 0 auto;
}
.element-type-font-style {
  font-weight: bold;
}
.element-icon-width-height {
  width: 19px;
  height: 14px;
}
.include-in-progress-width-height {
  width: 20px;
  height: 20px;
}
.bonus-icon-width-height {
  width: 35px;
  height: 35px;
}
.padding-top-5px {
  padding-top: 5px;
}
.element-index-font-style {
  font-size: 19px;
  color: #ffffff;
}
.element-index-circle-width-height {
  width: 35px;
  height: 35px;
  background-color: #f39c12;
}
.roundered-corner {
  border-radius: 17.5px;
}
.MilestoneElementList {
  width: 90%;
}
.element-name-style {
  font-weight: lighter;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 18px;
  height: 22px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.element-name-text-size {
  font-size: 16px;
}
.orange-text-color {
  color: #f39c12;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.padding-right-0Perc{
  padding-right: 0%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.width-5Perc{
  width: 5%;
}
.float-left{
  float: left;
}
.margin-5Perc {
  margin:5%;
}
.tooltip1 {
    position: relative;
    /* display: inline-block; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0.5px;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 140%;
    margin-left: -60px;
    font-size: 11px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.margin-right-0px {
  margin-right: 0px;
}
.margin-0px {
  margin: 0px;
}
.margin-left-2px {
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/MilestoneElementList.vue